import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { useUserSettingsTier } from "../@hooks"


export default function UserSettingTierTabButton() {
    const { handleSetTierFormData } = useUserSettingsTier()

    return <ButtonLoadingSeeker
        startIcon={<IconSeeker icon="add" />}
        onClick={handleSetTierFormData}
    >
        Define Tier
    </ButtonLoadingSeeker>
}